import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations.js'
import  getters from './getter.js'
import  actions from './actions.js'
import  state from './state.js'

Vue.use(Vuex);
const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js